module.exports = __webpack_public_path__ + "media/images/img_service_step_3-f058dbbac269fd73f5f8f5cf10332ba4.png";